$component-class: 'me-container';

.#{$component-class} {
  @include container;
}

@mixin generate-vertical-gap-modifiers($component, $gaps) {
  @each $key, $value in $gaps {
    .#{$component}--y-gap-#{$key} {
      padding-top: $value;
      padding-bottom: $value;
    }

    .#{$component}--y-gap-lg-#{$key} {
      @include desktop {
        padding-top: $value;
        padding-bottom: $value;
      }
    }
  }
}

@include generate-vertical-gap-modifiers($component-class, $spacings);
